"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Sparkle24DefaultSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M2 13.9293C6.13549 13.4134 9.41317 10.1356 9.92879 6H10.0702C10.5859 10.1359 13.864 13.4139 18 13.9295V14.0708C13.8641 14.5863 10.586 17.8642 10.0703 22H9.92877C9.41304 17.8645 6.13541 14.5868 2 14.0709L2 13.9293Z", fill: "#5E30E3" }),
        react_1.default.createElement("path", { d: "M15 5.46908C16.8093 5.24338 18.2433 3.80932 18.4688 2H18.5307C18.7563 3.80946 20.1905 5.2436 22 5.46913V5.53097C20.1906 5.7565 18.7564 7.19059 18.5307 9H18.4688C18.2432 7.19073 16.8092 5.75673 15 5.53102L15 5.46908Z", fill: "black" }));
}
function Sparkle24Default(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Sparkle24DefaultSvg, Object.assign({}, svgProps)));
}
exports.default = Sparkle24Default;
//# sourceMappingURL=Sparkle24Default.js.map